import Pie, { PieSegmentData as PSD } from "./Pie";

export default Pie;
export type PieSegmentData = PSD;
